import { CardContent } from '@mui/material';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import React from 'react';
import DateInput from '../input/DateInput';
import {TraceActionSelector} from "../Discount/TraceActionSelector";
import {TextInput} from "../input/TextInput";


export const BoxTraceFilters = ({filters, disabled, changeFilters}) => {
    return <Card sx={{backgroundColor: '#f4f4f4', marginBottom: 1}}>
        <CardContent>
            <Grid container sx={{maxWidth: '60%', marginLeft: '20%'}}>
                <Grid item lg={6} md={6} sm={12} sx={{padding: 2}}>
                    <TraceActionSelector
                        disabled={disabled}
                        label="Action"
                        onChange={action => changeFilters({action})}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} sx={{padding: 2}}>
                    <TextInput
                        variant="outlined"
                        disabled={disabled}
                        label="Box"
                        required={false}
                        onChange={box => changeFilters({box})}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} sx={{padding: 2}}>
                    <DateInput
                        label="Created from"
                        value={filters.createdFrom}
                        onChange={createdFrom => changeFilters({createdFrom})}
                        disabled={disabled}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} sx={{padding: 2}}>
                    <DateInput
                        label="to"
                        value={filters.createdTo}
                        onChange={createdTo => changeFilters({createdTo})}
                        disabled={disabled}
                    />
                </Grid>
            </Grid>
        </CardContent>
    </Card>
}
